module.exports = __webpack_public_path__ + "img/ICON_Dashboard_tickets_azul@6x.e2657d88.png";